import { FormControlLabel, FormControlLabelText } from "@gluestack-ui/themed";
import { IInputLabel } from "./types";

export const InputLabel = ({ label }: IInputLabel) => {
  if (!label) return null;

  return (
    <FormControlLabel mb="$1">
      <FormControlLabelText
        fontFamily="Roboto"
        color="$textLight800"
        fontWeight={500}
        size="sm"
      >
        {label}
      </FormControlLabelText>
    </FormControlLabel>
  );
};
